export const REDUCER_NAME="testimonialSlice"
export interface iTestimonialDTO {
    title?:string
    name?: string;
    description?: string;
    rating?: number;
    image?: string | File;
}

export interface iTestimonialResponse {
    id: string;
    vendorId: string;
    name: string;
    description: string;
    rating: number;
    image: string | null;
    createdAt: string;
    updatedAt: string;
}


export interface iTestimonialState {
    isLoading: boolean;
    testimonialList: iTestimonialResponse[];
    errorMessage: string | null;
  }